import _store from "../../../index";
import AMOAccount from "../../../classes/AMO/AMOAccount.js";

const defaultState = () => ({
  data: {}
});

const state = defaultState();

// getters
const getters = {
  account: state => amo => {
    if (!amo) {
      return undefined;
    }

    if ((state.data[amo.domain] || {}).received === undefined) {
      _store.dispatch("cache/amo_accounts/loadAccount", amo);
      return undefined;
    }
    return state.data[amo.domain].data;
  }
};

// actions
const actions = {
  async loadAccount(store, amo) {
    let domain = amo.domain;
    if ((state.data[domain] || {}).received !== undefined) {
      return;
    }
    await store.commit("appentAccountInfo", {
      domain,
      value: { received: false }
    });
    store.rootState.api
      .query({
        query: require("../../../../graphql/opupet_query.graphql"),
        variables: {
          class: "\\App\\SPAModels\\Amocrm\\AnemoneConnector",
          method: "getAccount",
          params: { amo }
        }
      })
      .then(res => {
        let value = {
          data: new AMOAccount(res.data.opupet_query),
          received: true
        };
        store.commit("appentAccountInfo", { domain, value });
      })
      .catch(() => {
        store.commit("appentAccountInfo", {
          domain,
          value: { received: undefined }
        });
      });
    return state;
  }
};

// mutations
const mutations = {
  resetState(state) {
    Object.assign(state, defaultState());
  },
  appentAccountInfo(state, { domain, value }) {
    state.data[domain] = value;
    let t;
    (t = {})[domain] = value;
    state.data = { ...state.data, ...t };
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
